import { defineStore } from 'pinia';

type WorkspaceStoreState = {
  pageLoader: boolean;
};

export const useWorkspaceStore = defineStore('workspaceStore', {
  state: (): WorkspaceStoreState => {
    return {
      pageLoader: false,
    };
  },
  getters: {},
  actions: {
    setPageLoader(loading: boolean) {
      this.pageLoader = loading;
    },
  },
});
